<template>
  <MostrarMensaje
    v-model:modelValue="error"
    status="error"
    :title="errorMsg"
    slug="error-guardado"
    :duration="2500"
    :closable="true"
  />

  <div id="parent" class="row min-vh-100 flex-column flex-lg-row m-0">
    <div
      class="col-12 col-lg-6 d-flex align-items-center justify-content-center stack-33 login-logo"
    >
      <img src="@/assets/img/logo_completo.png" class="img-fluid" alt="Logo" />
    </div>
    <div
      class="col-12 col-lg-6 d-flex align-items-center justify-content-center justify-content-lg-start stack-66"
    >
      <div id="frm-login" class="card rounded">
        <form @keydown.enter.prevent="onSubmit">
          <div class="mb-3">
            <label for="usuario" class="form-label">Usuario</label>
            <input
              type="text"
              class="form-control"
              id="usuario"
              v-model="usuarioVal"
            />
          </div>
          <div class="mb-3">
            <label for="password" class="form-label">Password</label>
            <input
              type="password"
              class="form-control"
              id="password"
              v-model="passVal"
            />
          </div>
          <div
            class="form-check d-flex justify-content-center align-items-center gap-2 ps-0 mb-3"
          >
            <input
              type="checkbox"
              class="form-check-input"
              id="recordarUsuario"
              v-model="recordarUserVal"
            />
            <label class="form-check-label" for="recordarUsuario"
              >Recordar usuario</label
            >
          </div>
          <button
            type="button"
            class="btn btn-primary"
            @click="onSubmit"
            :disabled="loading"
          >
            {{ loading ? "Ingresando" : "Iniciar Sesión" }}
          </button>
          <div class="text-center mt-3">
            <router-link class="forgot-link" to="/forgot-password">
              ¿Olvidaste tu contraseña?
            </router-link>
          </div>
        </form>
        <p v-if="ok" style="color: #2e7d32">¡Login OK!</p>
      </div>
    </div>
  </div>

  <MostrarMensaje
    v-model:modelValue="mostrarMensajeError"
    status="error"
    :message="mensajeError"
    slug="error-guardado"
    :duration="5000"
    :closable="true"
  />
</template>

<script setup lang="js">
import {ref, onBeforeUnmount, onMounted} from 'vue'
import MostrarMensaje from "@/components/MostrarMensaje.vue"
import { useStore } from 'vuex';

import { useRouter } from 'vue-router'

const mostrarMensajeError = ref(false)
const mensajeError = ref("")

const usuarioVal = ref('')
const passVal = ref('')
const recordarUserVal = ref(true)

const loading = ref(false)
const error = ref(false)
const errorMsg = ref('')
const ok = ref(false)

const store = useStore()
const router = useRouter()
const STORAGE_USER = 'app:last_username'

let controller = null

async function onSubmit() {
  error.value = false
  ok.value = false

  if (usuarioVal.value == '' || passVal.value == ''){
    error.value = true
    errorMsg.value = 'Es obligatorio ingresar el usuario y la contraseña para inicar sesión'
    return
  }

  if (controller) controller.abort()
  controller = new AbortController()

  loading.value = true
  try {
    // Llamada a POST /auth/login usando la base de VITE_API_URL
    await store.dispatch('auth/login', { usuario: usuarioVal.value, password: passVal.value })

    const redirectTo = sessionStorage.getItem('ac_redirect_to') || '/';

    if (recordarUserVal.value){
      localStorage.setItem(STORAGE_USER, usuarioVal.value)
    }

    if (redirectTo && redirectTo !== '/' && redirectTo !== '/login') {
      // redirectTo es un PATH completo, úsalo como string
      router.replace(redirectTo)
    } else {
      router.replace({ name: 'deportes' })
    }
    ok.value = true
  } catch (e) {
    console.error(e)

    error.value = true

    if (e?.code === 'SERVER_UNAVAILABLE') {
      errorMsg.value =
        'No se pudo conectar con el servidor. Intentá nuevamente en unos minutos.'
    } else if (e?.message?.startsWith('HTTP 401')) {
      errorMsg.value = 'El usuario o la contraseña son incorrectos.'
    } else {
      errorMsg.value =
        'Ocurrió un error al iniciar sesión. Intentá nuevamente.'
    }
  } finally {
    loading.value = false
    loading.value = false
  }
}

onBeforeUnmount(() => controller?.abort())

onMounted(()=> {
  const userDefault = localStorage.getItem(STORAGE_USER)
  if (userDefault){
    usuarioVal.value = userDefault
  }
  if (sessionStorage.getItem('ac_unauthorized') === "1") {
    sessionStorage.removeItem("ac_unauthorized");
    mostrarMensajeError.value = true
    mensajeError.value = "Tu sesión expiró. Volvé a iniciar sesión.";
  }
})
</script>

<style scoped>
#frm-login {
  padding: 20px;
  max-width: 350px;
  margin: 0;
  border: 2px solid rgb(134, 124, 124);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.06);
}

#parent {
  min-height: 100vh;
  min-height: 100dvh;
}

@media (max-width: 991.98px) {
  #parent {
    min-height: 100dvh;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    padding: 20px 16px 24px;
  }

  .stack-33,
  .stack-66 {
    flex: 0 0 auto;
    width: 100%;
  }

  .login-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }

  .login-logo img {
    width: 230px;
    max-width: 70vw;
  }

  #frm-login {
    width: 100%;
    max-width: 310px;
    margin: 0 auto;
  }
}

img {
  max-width: 100%;
  height: auto;
}

.forgot-link {
  font-size: 0.95rem;
  text-decoration: none;
}

.forgot-link:hover {
  text-decoration: underline;
}

#parent {
  min-height: 100vh;
  background: linear-gradient(135deg, #eef4f7 0%, #f7fafc 45%, #e8f5ef 100%);
}

.login-logo {
  filter: drop-shadow(0 3px 4px rgba(0, 0, 0, 0.18));
}
</style>
